import { Action } from '@ngrx/store';
import { NotificationInterface, NotificationTemplateInterface } from 'app/notifications/models';
import { NotificationServiceFilters } from 'app/notifications/services/notification.service';

import { NotificationActionType } from './notification-action-type.enum';

export class LoadNotifications implements Action {
  public readonly type: NotificationActionType = NotificationActionType.LoadNotifications;

  constructor(public readonly payload?: NotificationServiceFilters) { }
}

export class LoadNotificationsCompleted implements Action {
  public readonly type: NotificationActionType = NotificationActionType.LoadNotificationsCompleted;

  constructor(public readonly payload: NotificationInterface[]) { }
}

export class LoadNotificationsFailed implements Action {
  public readonly type: NotificationActionType = NotificationActionType.LoadNotificationsFailed;

  constructor(public readonly payload: string) { }
}

export class LoadNotificationTemplates implements Action {
  public readonly type: NotificationActionType = NotificationActionType.LoadNotificationTemplates;

  constructor(public readonly payload: any = undefined) { }
}

export class LoadNotificationTemplatesCompleted implements Action {
  public readonly type: NotificationActionType = NotificationActionType.LoadNotificationTemplatesCompleted;

  constructor(public readonly payload: NotificationTemplateInterface[]) { }
}

export class LoadNotificationTemplatesFailed implements Action {
  public readonly type: NotificationActionType = NotificationActionType.LoadNotificationTemplatesFailed;

  constructor(public readonly payload: any = undefined) { }
}
